export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <circle stroke="#979797" strokeWidth="2" cx="38.5" cy="38.5" r="27.5" />
                <path
                    d="M42.32 37.668c7.267-13.207 5.633-20.075-4.9-20.603-12.865 1.814-3.59 15.319 1.08 19.116 1.647 1.118 2.92 1.614 3.82 1.487zM38.162 42.258c7.804 12.898 14.569 14.917 20.293 6.058 4.862-12.048-11.472-10.767-17.096-8.622-1.791.867-2.857 1.722-3.197 2.564zM35.988 37.202c-15.072.31-20.203 5.16-15.393 14.546 8.003 10.234 15.061-4.551 16.015-10.494.145-1.986-.063-3.336-.622-4.052z"
                    stroke="#979797"
                    strokeWidth="2"
                />
                <circle stroke="#979797" strokeWidth="2" fill="#03060B" cx="38.5" cy="39.5" r="4.5" />
            </g>
        </svg>
    );
}
